import * as types from './mutation-types'
let defaultObject = () => ({
  data: {
    name: '',
  }
})

export default {
  [types.SET_PARTICIPANT] (state, payload) {
    if (payload === null) {
      payload = defaultObject()
    }
    state.participant = payload
  }
}
